import { LayerType } from "../../types";
import { ConstraintsLayerType } from "../ConstraintsLayerType";
import { HazardFloodingLayerSummary } from "./HazardFloodingLayerSummary";
import { HazardWetlandsLayerSummary } from "./HazardWetlandsLayerSummary";

export const HazardFloodingLayerType: LayerType = {
  ...ConstraintsLayerType,
  id: ConstraintsLayerType.id,
  LayerSummary: HazardFloodingLayerSummary,
};

export const HazardFloodingSummaryLayerType: LayerType = {
  id: `${HazardFloodingLayerType.id}--summary`,
  LayerSummary: HazardFloodingLayerSummary,
};

export const HazardWetlandsLayerType: LayerType = {
  ...ConstraintsLayerType,
  id: ConstraintsLayerType.id,
  LayerSummary: HazardWetlandsLayerSummary,
};

export const HazardWetlandsSummaryLayerType: LayerType = {
  id: `${HazardWetlandsLayerType.id}--summary`,
  LayerSummary: HazardWetlandsLayerSummary,
};
